import React, {Component} from 'react';
import Login from "./components/Login/Login.js";
import ForgotPassword from "./components/Login/ForgotPassword.js";
import ResetSent from "./components/Login/ResetSent.js";
import ResetPassword from "./components/Login/ResetPassword.js";
import AdminAssemblies from "./components/Admin/Dashboard/Assemblies.js";
import ProductListings from "./components/Admin/Dashboard/ProductListings.js";
import EditProductListing from "./components/Admin/Dashboard/EditProductListing.js";
import CustomerCarts from "./components/Admin/Dashboard/CustomerCarts.js";
import EditCustomerCart from "./components/Admin/Dashboard/EditCustomerCart.js";
import AdminParts from "./components/Admin/Dashboard/Parts.js";
import {Route, BrowserRouter, Switch} from "react-router-dom";
import {createBrowserHistory} from "history";
import './App.css';
import './responsive.css';
import ScrollToTop from "./ScrollToTop";
import GlobalSnackbar from "./components/Common/GlobalSnackbar";
import AdminParentChild from "./components/Admin/Dashboard/ParentChild";
import AdminPackaging from "./components/Admin/Dashboard/Packaging";
import AdminBOM from "./components/Admin/Dashboard/BillOfMaterials";
import AdminInventory from "./components/Admin/Dashboard/Inventory";
import AdminInventorySetup from "./components/Admin/Dashboard/InventorySetup";
import AdminPurchases from "./components/Admin/Dashboard/Purchases";
import EditPurchaseOrder from "./components/Admin/Dashboard/EditPurchaseOrder";
import AdminInvoices from "./components/Admin/Dashboard/Invoices";
import AdminPackingSlips from "./components/Admin/Dashboard/PackingSlips";
import ViewPackingSlip from "./components/Admin/Dashboard/ViewPackingSlip";
import EditPackingSlipBox from "./components/Admin/Dashboard/EditPackingSlipBox";
import AdminSales from "./components/Admin/Dashboard/Sales";
import AdminOrders from "./components/Admin/Dashboard/Orders";
import AdminShippingMethods from "./components/Admin/Dashboard/ShippingMethods";
import AdminAnalytics from "./components/Admin/Dashboard/Analytics";
import AdminLists from "./components/Admin/Dashboard/Lists";
import AdminDealerSheet from "./components/Admin/Dashboard/DealerSheet";
import Package from "./components/Workshop/Package";
import Inventory from "./components/Workshop/Inventory";
import SetInventory from "./components/Workshop/SetInventory";
import InventorySession from "./components/Workshop/InventorySession";
import BillOfMaterials from "./components/Workshop/BillOfMaterials";
import Search from "./components/Workshop/Search";
import Purchase from "./components/Workshop/Purchase";
import EditPart from "./components/Admin/Dashboard/EditPart";
import EditAssembly from "./components/Admin/Dashboard/EditAssembly";
import AdminVendors from "./components/Admin/Dashboard/Vendors";
import AdminImportUtilities from "./components/Admin/Dashboard/ImportUtilities";
import Unpackage from "./components/Workshop/Unpackage";
import Sell from "./components/Workshop/Sell";
import PackageFamily from "./components/Workshop/PackageFamily";
import BomCheck from "./components/Workshop/BomCheck";
import Families from './components/Admin/Dashboard/Families.js';
import MyProfile from './components/Profile/MyProfile.js';
import MyProfileMobile from './components/Profile/MyProfileMobile.js';
import UserManagement from './components/Admin/Dashboard/UserManagement.js';
import HomepageCategories from './components/Admin/Dashboard/HomepageCategories.js';
import { AuthenticationService } from './Services/AuthenticationService';

const history = createBrowserHistory();

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {};
        
        // Initialize authentication service
        AuthenticationService.getInstance().initialize();
        
        window.$alertError = this.alertError;
        window.$alertWarning = this.alertWarning;
        window.$alertSuccess = this.alertSuccess;
        window.$toLocalDateTimeString = this.toLocalDateTimeString;
    }

    alertError = (errorMessage) => {
        this.setState({
            errorOpen: true,
            errorTime: new Date(),
            errorMessage: errorMessage,
            errorDuration: 5000
        });
    };

    alertWarning = (warningMessage) => {
        this.setState({
            warningOpen: true,
            warningTime: new Date(),
            warningMessage: warningMessage,
            warningDuration: 5000
        });
    };

    alertSuccess = (successMessage) => {
        this.setState({
            successOpen: true,
            successTime: new Date(),
            successMessage: successMessage,
            successDuration: 5000
        });
    };

    toLocalDateTimeString = (dateInput) => {
        const date = new Date(dateInput);
        const dateString = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()} UTC`;
        const parsedDate = new Date(Date.parse(dateString));
        
        // Format time with leading zeros
        const timeOptions = { 
            hour: '2-digit', 
            minute: '2-digit', 
            hour12: true 
        };
        const timeString = parsedDate.toLocaleTimeString([], timeOptions);
        
        const returnString = `${parsedDate.toLocaleDateString("en-CA")} - ${timeString}`;
        return returnString === 'Invalid Date Invalid Date' ? '12:00 AM' : returnString;
    };

    render() {
        return (
            <BrowserRouter history={history}>
                <div className="App">
                    <ScrollToTop />
                    <GlobalSnackbar
                        variant="error"
                        open={this.state.errorOpen}
                        time={this.state.errorTime}
                        message={this.state.errorMessage}
                        autoHideDuration={this.state.errorDuration}
                    />
                    <GlobalSnackbar
                        variant="warning"
                        open={this.state.warningOpen}
                        time={this.state.warningTime}
                        message={this.state.warningMessage}
                        autoHideDuration={this.state.warningDuration}
                    />
                    <GlobalSnackbar
                        variant="success"
                        open={this.state.successOpen}
                        time={this.state.successTime}
                        message={this.state.successMessage}
                        autoHideDuration={this.state.successDuration}
                    />
                    <Route exact path="/" component={Login}/>
                    <Route exact path="/login/:redirect?" component={Login}/>
                    <Route exact path="/package/:assemblyId" component={Package}/>
                    <Route exact path="/unpackage/:assemblyId" component={Unpackage}/>
                    <Route exact path="/inventory/:partId" component={Inventory}/>
                    <Route exact path="/set-inventory/:partId" component={SetInventory}/>
                    <Route exact path="/inventory/session/:sessionId" component={InventorySession}/>
                    <Route exact path="/package/family/:assemblyFamilyId?" component={PackageFamily}/>
                    <Route exact path="/purchase/:partId" component={Purchase}/>
                    <Route exact path="/sell/:partOrAssembly" component={Sell}/>
                    <Route exact path="/search/:partOrAssembly?" component={Search}/>
                    <Route exact path="/bom/:assemblyId?" component={BillOfMaterials}/>
                    <Route exact path="/bom/check/:assemblyId?" component={BomCheck}/>
                    <Route exact path="/password/forgot" component={ForgotPassword}/>
                    <Route exact path="/password/sent" component={ResetSent}/>
                    <Route exact path="/password/reset/:resetId" component={ResetPassword}/>
                    <Route exact path="/admin/families" component={Families}/>
                    <Route exact path="/admin/assemblies/:assemblyId" render={(props) => <EditAssembly key={props.match.params.assemblyId} {...props} />}/>
                    <Route exact path="/admin/parts/:partId" component={EditPart}/>
                    <Route exact path="/admin/assemblies" component={AdminAssemblies}/>
                    <Route exact path="/admin/product-listings/:listingId" render={(props) => <EditProductListing key={props.match.params.listingId} {...props} />}/>
                    <Route exact path="/admin/product-listings" component={ProductListings}/>
                    <Route exact path="/admin/customer-carts/:cartId" render={(props) => <EditCustomerCart key={props.match.params.cartId} {...props} />}/>
                    <Route exact path="/admin/customer-carts" component={CustomerCarts}/>
                    <Route exact path="/admin/parentchild" component={AdminParentChild}/>
                    <Route exact path="/admin/parts" component={AdminParts}/>
                    <Route exact path="/admin/vendors" component={AdminVendors}/>
                    <Route exact path="/admin/packaging/:logs?" component={AdminPackaging}/>
                    <Route exact path="/admin/bom" component={AdminBOM}/>
                    <Route exact path="/admin/inventory/:logs?" component={AdminInventory}/>
                    <Route exact path="/admin/inventory/session/:sessionId" component={AdminInventorySetup}/>
                    <Route exact path="/admin/purchases" component={AdminPurchases}/>
                    <Route exact path="/admin/purchases/edit/:purchaseOrderId" component={EditPurchaseOrder}/>
                    <Route exact path="/admin/invoices/:invoiceId?" component={AdminInvoices}/>
                    <Route exact path="/admin/packing-slips/box/:packingSlipId" component={EditPackingSlipBox}/>
                    <Route exact path="/admin/packing-slips/:packingSlipId" component={ViewPackingSlip}/>
                    <Route exact path="/admin/packing-slips" component={AdminPackingSlips}/>
                    <Route exact path="/admin/sales/:salesLogSequence?" component={AdminSales}/>
                    <Route exact path="/admin/orders/:orderId?" component={AdminOrders}/>
                    <Route exact path="/admin/shipping-methods" component={AdminShippingMethods}/>
                    <Route exact path="/admin/analytics" component={AdminAnalytics}/>
                    <Route exact path="/admin/lists" component={AdminLists}/>
                    <Route exact path="/admin/dealer-sheet" component={AdminDealerSheet}/>
                    <Route exact path="/admin/import" component={AdminImportUtilities}/>
                    <Route exact path="/admin/users" component={UserManagement}/>
                    <Route exact path="/admin/customer-site-controls" component={HomepageCategories}/>
                    <Route exact path="/admin/homepage-categories" component={HomepageCategories}/>
                    <Route exact path="/admin/profile" component={MyProfile}/>
                    <Route exact path="/profile" component={MyProfileMobile}/>
                </div>
            </BrowserRouter>
        );
    }
}

export default App;
